export default "__VITE_ASSET__CtzQ7kPo__"